import React from 'react';
import PropTypes from 'prop-types';

import IconPreview from './svg/IconPreview';
import IconPreviewPause from './svg/IconPreviewPause';

function ButtonPreview({ isPlay = false, className, style, onClick }) {
  return (
    <div onClick={onClick} className={`preview-button ${isPlay && `playing`} ${className} `} style={{...style, cursor: 'pointer'}}>
      { !isPlay ? <IconPreview /> : <IconPreviewPause /> }
    </div>
  )
}

ButtonPreview.propTypes = {
  isPlay:  PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
}

export default ButtonPreview;
